




























































































































































import { Component, Vue } from "vue-property-decorator";
import TrainBoxKO from "@/components/TrainBoxKO.vue";
import { TrainKO } from "@/types";

@Component({ components: { TrainBoxKO } })
export default class Policy extends Vue {
  readonly trainExample1: TrainKO = {
    tr: "1834",
    sy: "62",
    ki: false,
    dl: 0,
    ik: "891"
  };
  readonly trainExample2: TrainKO = {
    tr: "3203",
    sy: "46",
    ki: true,
    dl: 0,
    ik: "801"
  };
}
